
import { Link, useLocation } from "react-router-dom";
import { motion, useReducedMotion, useScroll, useSpring } from "framer-motion";
import { GitCompareArrows, Home, ScanSearch } from "lucide-react";
import { useHealth } from "../lib/health";
import { SPRING } from "../lib/motion";

const LINKS = [
  { to: "/", label: "Overview", icon: Home },
  { to: "/injection", label: "Injection", icon: ScanSearch },
  { to: "/compare", label: "Compare", icon: GitCompareArrows },
];

const STATUS_TEXT = {
  checking: "Checking",
  online: "Service up",
  offline: "Service down",
};

function Navbar() {
  const location = useLocation();
  const prefersReducedMotion = useReducedMotion();
  const health = useHealth();

  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 260, damping: 40, mass: 0.5 });

  return (
    <nav className="nav" aria-label="Primary">
      <div className="shell shell--wide nav__inner">
        <Link to="/" className="nav__brand" aria-label="DocCompare home">
          <img src="/logo.png" alt="DocCompare" />
          <span className="nav__brand-tag" aria-hidden="true">
            v2
          </span>
        </Link>

        <div className="nav__links">
          {LINKS.map(({ to, label, icon: Icon }) => {
            const active = location.pathname === to;
            return (
              <Link
                key={to}
                to={to}
                className="nav__link"
                aria-current={active ? "page" : undefined}
              >
                {active && (
                  <motion.span
                    className="nav__pill"
                    layoutId="nav-pill"
                    transition={prefersReducedMotion ? { duration: 0 } : { type: "spring", ...SPRING.pill }}
                  />
                )}
                <span className="nav__link-label row" style={{ gap: "var(--space-2)" }}>
                  <Icon size={14} aria-hidden="true" />
                  {label}
                </span>
              </Link>
            );
          })}
        </div>

        <div className="nav__actions">
          <span className="nav__status" data-state={health}>
            <span className="nav__dot" aria-hidden="true" />
            {STATUS_TEXT[health]}
          </span>
        </div>
      </div>

      {/* Reading position. Decorative: the same information is the scrollbar. */}
      <motion.div className="nav__progress" style={{ scaleX: progress }} aria-hidden="true" />
    </nav>
  );
}

export default Navbar;
